import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import http from '@/utils/http';
import { useRequest, useUpdateEffect } from 'ahooks';
import { Pagination, PagingQuery, Table } from 'tea-component';
import classNames from 'classnames';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import TableForm from '../TableForm/index';
import './index.scss';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';

const fetchData = async (payload: { url: string; params: any }) => {
  const { url, params } = payload || {};
  return http({
    url,
    method: 'post',
    data: params,
  });
};

function TableContent(props: any, ref: any) {
  const {
    url,
    columns,
    resultKey,
    preParams,
    lastResultData,
    loading,
    immediately = true,
    handerSearch = false,
    searchForm,
    className,
    sort = [],
    addons,
    ...rest
  } = props;
  const { sortable } = Table.addons;
  const { formatMessage } = useIntlExtend();
  const [sorts, setSorts] = useState(sort || []);
  const defaultPageSize = 100;
  // 设置初始化页面分页数据
  const [pageData, setPageData]: any = useState({
    pageSizeOptions: [20, 30, 50, 100, 200],
    page: 1,
    page_size: 20,
    total: 0,
  });

  const { runAsync: fetchDataRunAsync } = useRequest(fetchData, {
    debounceWait: 300,
    manual: true,
  });

  const [tableData, setTableData] = useState([]);
  // 处理排序参数
  const dealSort = (sortData: any) => {
    return sortData?.map((item: any) => `${item.by} ${item.order}`);
  };
  // 获取所有数据
  const getAllData = async (page?: number) => {
    // 处理参数
    const sortsParms = dealSort(sorts);
    let params = { ...pageData, order_by: sortsParms };
    if (page) {
      params.page = page;
    }
    if (preParams) params = preParams(params);
    // const res: any = await http({
    //   url,
    //   method: 'post',
    //   data: params,
    // });
    const res: any = await fetchDataRunAsync({ url, params });
    let result = res[resultKey || 'data'];
    if (lastResultData) result = lastResultData(result);
    setTableData(result);
    // 设置页面参数
    setPageData({ ...pageData, total: res.count || res.total });
  };
  // 排序数据收集
  const sortData = (columns?: any) => {
    const sortArr: any[] = [];
    columns?.map((item: any) => {
      if (item?.sortMethod) {
        sortArr.push({
          key: item.key,
          prefer: item?.prefer || 'desc',
          sorter: item.sortMethod,
        });
      }
      if (item?.sort && !item?.prefer) {
        sortArr.push({
          key: item.key,
          prefer: item?.prefer || 'desc',
        });
      }
      if (item?.sort && item?.prefer) {
        sortArr.push({
          key: item.key,
          prefer: item?.prefer || 'desc',
        });
      }
    });
    return {
      columns: sortArr,
      value: sorts,
      onChange: (value: any) => {
        if (value.length === 0) {
          value = sort;
        } else {
          value = [value[0]];
        }
        setSorts(value);
      },
    };
  };

  // const [showShadow, setShowShadow] = useState(false);
  const onPagingChange = (e: PagingQuery) => {
    setPageData({ ...pageData, page_size: e.pageSize || defaultPageSize, page: e.pageIndex });
  };

  useUpdateEffect(() => {
    if (!handerSearch) getAllData();
  }, [pageData.page_size, pageData.page, sorts]);

  // 是否首次执行
  useEffect(() => {
    // immediately
    if (immediately) getAllData();
  }, []);

  useImperativeHandle(ref, () => ({
    search: (page?: number) => getAllData(page), // 暴露 搜索方法
    initParams: () => {
      setPageData({ pageSizeOptions: [20, 30, 50, 100, 200], page: 1, page_size: 20, total: 0 });
      setSorts(sort || []);
    },
  }));
  return (
    <div
      className={`${className} ${classNames('dbi-table-content', {
        'table-sticky-two': true,
        'table-sticky-two-shadow': false,
      })}`}
      style={{ ...rest.style, height: '600px' }}
      id="topchart-metrics-table"
    >
      <TableForm configForm={searchForm}></TableForm>
      <>
        {loading ? (
          <Loading></Loading>
        ) : tableData.length === 0 ? (
          <NoData style={{ height: '400px' }} text={formatMessage({ id: 'dbi_detail_no_data_under' })} />
        ) : (
          <Table
            bordered="all"
            addons={[...addons, sortable(sortData(columns))]}
            records={tableData}
            columns={columns}
            {...rest}
          />
        )}
        {!loading && tableData.length > 0 && (
          <Pagination
            pageSizeOptions={pageData.pageSizeOptions}
            onPagingChange={onPagingChange}
            pageSize={pageData.page_size}
            pageIndex={pageData.page}
            recordCount={pageData.total}
            stateTextVisible={true}
            pageSizeVisible={pageData.total > pageData.pageSizeOptions[0]}
            pageIndexVisible={pageData.total > pageData.pageSizeOptions[0]}
            jumpVisible={pageData.total > pageData.pageSizeOptions[0]}
            endJumpVisible={pageData.total > pageData.pageSizeOptions[0]}
            stateText={formatMessage({ id: 'dbi_pagination_total' }, { total: pageData.total ?? 0 })}
          />
        )}
      </>
    </div>
  );
}
export default forwardRef(TableContent);
